module.exports = __webpack_public_path__ + "static/img/img-rkzxqy-modeal-3.568454c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/img-rkzxqy-modeal-3.png
// module id = BCAm
// module chunks = 1